import { Box } from "@mui/material"
import { BarModal } from "./BarModal"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useAPI } from "../../hooks/useAPI";
import { BarData, CountryData } from "../../types";
import { useAuth } from "../../assets/contexts/AuthContext";

interface EditBarProps {
  countries: CountryData[];
  refetchBars: () => void;
}

export const EditBar = ({ countries, refetchBars }: EditBarProps) => {
  const { bar_id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { fetchData } = useAPI();
  const [bar, setBar] = useState<BarData>({});
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();

  const handleClose = () => {
    setOpen(false);
    navigate('/bars');
  }

  const handleSave = () => {
    navigate('/bars');
    refetchBars();
  }
  
  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/bars/${bar_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setBar(data);
        setOpen(true);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [isAuthenticated, bar_id]);
  
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="edit-bar">
      <BarModal open={open} handleClose={handleClose} handleSave={handleSave} bar={bar} countries={countries} />
    </Box>
  )
}